var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.hasPermission('automaticSentences.categories.view'))?_c('Categories',{staticClass:"mb-2"}):_vm._e(),(_vm.hasPermission('automaticSentences.sentences.view'))?_c('Sentences'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }